'use client'

import * as React from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { useNotifications } from '@repo/notifications/use-notifications'
import type { NotificationPayload } from '@repo/notifications/use-notifications'
import { useUserCoinBalanceQuery } from 'codegen/generated/coins'
import { useUserIdQuery } from 'auth/hooks'
import { applyUserCoinBalanceNotification } from './apply-user-coin-balance-notification'

const BALANCE_UPDATED_EVENT = {
  coins: {
    balanceUpdated: {},
  },
}

export function RefreshCoinBalance() {
  const queryClient = useQueryClient()
  const { data: userId } = useUserIdQuery()

  const onNotification = React.useCallback(
    (notification: NotificationPayload) => {
      applyUserCoinBalanceNotification(
        queryClient,
        notification,
        userId,
        useUserCoinBalanceQuery.getKey(),
      )
    },
    [queryClient, userId],
  )

  // The menu reads the GraphQL userBalance query. Studio writes a different cache
  // when this event arrives, so the number in the header stays put until reload.
  useNotifications({
    event: BALANCE_UPDATED_EVENT,
    onNotification,
    enabled: Boolean(userId),
  })

  return null
}
